module.exports = __webpack_public_path__ + "static/media/image-off.a8b3439d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/image-off.svg
// module id = 769
// module chunks = 0